// src/views/Parametros/Informacion/VerInformacion.jsx
import React, { useEffect, useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { apiFetchJson } from "../../../utils/http";

export default function VerInformacion({ item, onClose = () => {} }) {
  // 🟢 NOTA IMPORTANTE:
  // En tu ListarInformacion usas datos MOCK o el item completo del listado.
  // Por eso acá NO llamamos a la API a menos que quieras cargar detalle real.
  // Igual dejo la estructura preparada.

  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [info, setInfo] = useState(item || null);

  useEffect(() => {
    if (!item?.id) return;

    const USE_MOCK = true; // cambiar a false cuando tengas API real
    if (USE_MOCK) {
      setInfo(item);
      return;
    }

    let abort = new AbortController();
    async function load() {
      setLoading(true);
      setErr("");
      try {
        // API REAL (cuando la tengas)
        // const url = apiRoutes.informacion.detail(item.id);
        // const data = await apiFetchJson(url, { signal: abort.signal });
        // setInfo(data);
      } catch (e) {
        if (e?.name !== "AbortError") {
          setErr(e?.message || "Error al cargar la información.");
        }
      } finally {
        setLoading(false);
      }
    }
    load();

    return () => abort.abort();
  }, [item]);

  // ░░ Filas a mostrar ░░
  const rows = [
    ["Fecha", info?.fecha ?? ""],
    ["Información", info?.informacion ?? ""],
    ["Cliente", info?.cliente ?? "TODOS"],
    ["EE.SS.", info?.eess ?? "TODOS"],
  ];

  return (
    <div className="modal-backdrop">
      <div className="modal-panel-lg">
        {/* Header */}
        <div className="modal-header">
          <h2 className="section-title">Detalle de Información</h2>
        </div>

        {/* Body */}
        <div className="modal-body">
          {loading && (
            <div className="py-6 text-center text-gray-600">Cargando…</div>
          )}

          {!loading && err && (
            <div className="py-6 text-center text-red-600">{err}</div>
          )}

          {!loading && !err && info && (
            <>
              <div className="form-grid mb-4">
                {rows.map(([label, value]) => (
                  <Fila key={label} label={label} value={value} />
                ))}
              </div>
            </>
          )}
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <div className="flex justify-end">
            <button className="btn-fil" onClick={onClose}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Fila({ label, value }) {
  return (
    <div className="form-row">
      <div className="form-label">{label}:</div>
      <div className="value whitespace-pre-wrap">{value || ""}</div>
    </div>
  );
}
